
import React, { forwardRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { IconDerecha, IconIzquierda, IconArriba, IconAbajo, IconMenu } from '@portal/arq-portal-core';
//import SwapVertIcon from '@material-ui/icons/SwapVert';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import Card from '@material-ui/core/Card';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Checkbox from '@material-ui/core/Checkbox';
import {
  closestCenter,
  DndContext,
  //DragOverlay,
  KeyboardSensor,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
  useSortable
} from "@dnd-kit/sortable";
import { CSS } from '@dnd-kit/utilities';
import {
  restrictToVerticalAxis,
  restrictToWindowEdges,
} from '@dnd-kit/modifiers';

//import MockMiEspacio from '../mocks/mi_espacio2.json';
import { IGestionListasItem as IListItem, GestionMultiListasProps, IListas } from '../types/types';
import { IconButton, Tab, Tabs } from '@material-ui/core';


enum NombreLista {
  Disponibles = "Disponibles",
  Seleccionados = "Seleccionados"
}

const useEstilosMiEspacio = makeStyles((theme) => ({
  root: {
    margin: 'auto',
  },
  cardHeader: {
    padding: theme.spacing(1, 2),
  },
  itemSeleccionados: {
    
  },
  list: {
    width: '100%',
    height: 330,
    backgroundColor: theme.palette.background.paper,
    overflow: 'auto',
    paddingTop: '0px',
    paddingBottom: '0px',
    '@media screen and (max-width: 767px)': {
      height: 'auto',
    },
    '& div.MuiListItem-gutters': {
      borderBottom: '1px solid #d6d8d8',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#f4f4f4',
      }
    },
    '& > div': {
      borderBottom: '1px solid #d6d8d8',
      '&:hover': {
        backgroundColor: '#f4f4f4',
      }
    },
    '& li.MuiListItem-gutters': {
      paddingTop: '0px',
      paddingBottom: '0px',

    },
    '& .MuiListItem-root.Mui-disabled' : {
      opacity: '1',
      '& .MuiListItemText-root': {
        color: '#d6d8d8',
        pointerEvents: 'none',
      },
    },
    '& .MuiListItemText-root': {
      color: '#606060',
      pointerEvents: 'none',
    },
    '& .MuiListItemIcon-root': {
      minWidth: '40px',
    },
    '& .MuiIconButton-root': {
      color: '#606060',
    },
    '& .Mui-checked.MuiIconButton-root': {
      color: '#DC0028', 
    },
    '& .Mui-disabled.MuiIconButton-root': {
      color: '#d6d8d8', 
    },
    '& .MuiTouchRipple-root': {
      display: 'none',
    }
  },
  listSeleccionados: {
    '& > div': {
      '& > div': {
        width: '100%',
      },   
    } 
  },
  button: {
    margin: theme.spacing(0.5, 0),
  },
  titulo: {
    padding: "12px 0",
    color: theme.palette.primary.main,
    fontWeight: 700
  },
  zonaDisponibles: {
    width:'calc(50% - 60px)',
    maxWidth: '400px',
    '@media screen and (max-width: 959px)': {
      width:'calc(50% - 30px)',
    },
    '@media screen and (max-width: 767px)': {
      width: '100%',
    },
  },
  zonaAccionesCentro: {
    width:'120px',
    padding: '5px !important',
    '@media screen and (max-width: 959px)': {
        width:'60px',
    },
    '@media screen and (max-width: 767px)': {
      width: '100%',
      paddingBottom: '0px !important',
      '& .MuiGrid-align-items-xs-center' : {
        flexDirection: 'unset',
        justifyContent: 'center',
        '& .MuiButtonBase-root': {
          transform: 'rotate(90deg)',
        }
      }
    },
  },
  zonaSeleccionados: {
    width:'calc(50% - 60px)',
    maxWidth: '400px',
    '@media screen and (max-width: 959px)': {
      width:'calc(50% - 30px)',
    },
    '@media screen and (max-width: 767px)': {
      width: '100%',
    },
  }

  

}));

const useEstlosItem = makeStyles(() => ({
  encima: {
    "&:hover #icono-desplazar": {
      opacity: 1
    }
  },
  icono: {
    opacity: 0,
    transition: 'all 0.2s'
  }

}));


const no = (a: IListItem[], b: IListItem[]) => {
  return a.filter((componenteA) => (b.findIndex(componenteB => componenteA.id === componenteB.id) === -1));
}

const interseccion = (a: IListItem[], b: IListItem[]) => {
  return a.filter((componenteA) => (b.findIndex(componenteB => componenteA.id === componenteB.id) !== -1));
}

// @ts-ignore
const GestionMultiplesListas = React.forwardRef((props: GestionMultiListasProps, ref): JSX.Element => {

  const clases = useEstilosMiEspacio();
  const nombreLista = NombreLista;
  const [listaSeleccionada, setearListaSeleccionada] = React.useState<number>(0);
  const [listas, setearListas] = React.useState<IListas[]>(JSON.parse(JSON.stringify(props.listasDisponibles)));
  const [checkboxMarcadosArr, setearCheckboxMarcadosArr] = React.useState<IListItem[]>([]);
  const [listaIzquierda, setearListaIzquierda] = React.useState<IListItem[]>([]);
  const [listaDerecha, setearListaDerecha] = React.useState<IListItem[]>(JSON.parse(JSON.stringify(props.seleccionados)));

  React.useImperativeHandle(ref, () => ({
    getSave() {
      return listaDerecha;
    }
  }));

  // @ts-ignore
  const [activeId, setActiveId] = React.useState(null);
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 20
      }
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
    useSensor(TouchSensor, {
      activationConstraint: {
        distance: 20
      }
    })
  );

  const listaIzquierdaCheckeados = interseccion(checkboxMarcadosArr, listaIzquierda);
  const listaDerechaCheckeados = interseccion(checkboxMarcadosArr, listaDerecha);
  const listaDerechaCheckeadosNoFijos = listaDerechaCheckeados.filter(componente => !componente.fijo);

  React.useEffect( () => {
    setearListaIzquierda([...listas[listaSeleccionada].items]);
  }, [listaSeleccionada]);

  const manejarToggle = (value: IListItem) => () => {
    if (!value?.fijo) {
      if(value.idListaOrigen === undefined) value.idListaOrigen = listas[listaSeleccionada].id;
      const currentIndex = checkboxMarcadosArr.indexOf(value);
      const newChecked = [...checkboxMarcadosArr];
      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }
      setearCheckboxMarcadosArr(newChecked);
    }
  };
  
  const manejarPonerMarcadosALaDerecha = () => {
    if (listaDerecha.length < (props.maxSeleccionados ?? Infinity)) {
      let nuevaListaIzq = no(listaIzquierda, listaIzquierdaCheckeados);
      let nuevoMarcadosArr = no(checkboxMarcadosArr, listaIzquierdaCheckeados);
      setearListaDerecha(listaDerecha.concat(listaIzquierdaCheckeados));
      setearListaIzquierda([...nuevaListaIzq]);
      listas[listaSeleccionada].items = nuevaListaIzq;
      setearListas([...listas]);
      setearCheckboxMarcadosArr(nuevoMarcadosArr);
    }
  };

  const manejarPonerMarcadosALaIzquierda = () => {
    let nuevoMarcadosArr = no(checkboxMarcadosArr, listaDerechaCheckeadosNoFijos);
    let nuevaListaDerecha = no(listaDerecha, listaDerechaCheckeadosNoFijos);

    listaDerechaCheckeadosNoFijos.forEach( (item) => {
      let lista = listas.find( lista => lista.id === item.idListaOrigen );
      lista?.items.push(item);
    });
    setearListas([...listas]);
    setearListaIzquierda(listas[listaSeleccionada].items);
    setearListaDerecha(nuevaListaDerecha);
    setearCheckboxMarcadosArr(nuevoMarcadosArr);
  };

  // lista disponibles
  const listaDisponibles = (items: IListItem[]) => {
    return (
      <List className={clases.list} dense component="div" role="list" >
        {items.sort((a, b) => {
          if (a.titulo < b.titulo) { return -1; }
          if (a.titulo > b.titulo) { return 1; }
          return 0;
        }).map((item: IListItem) => {
          const labelId = `transfer-list-all-item-${item}-label`;
          return (
            <ListItem key={item.id} role="listitem" button onClick={manejarToggle(item)} disabled={item.fijo || (listaIzquierdaCheckeados.indexOf(item) === -1 && (listaDerecha.length + listaIzquierdaCheckeados.length >= (props.maxSeleccionados ?? Infinity))) ? true : false}>
              <ListItemIcon >
                <Checkbox
                  style={{ padding: 0 }}
                  checked={checkboxMarcadosArr.indexOf(item) !== -1}
                  tabIndex={-1}
                  disableRipple
                  disabled={item.fijo || (listaIzquierdaCheckeados.indexOf(item) === -1 && (listaDerecha.length + listaIzquierdaCheckeados.length >= (props.maxSeleccionados ?? Infinity))) ? true : false}
                  inputProps={{ 'aria-labelledby': labelId }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={item.titulo} />
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    )
  }

  // sorteable list - Mi espacio
  const Item = forwardRef<HTMLDivElement, any>((props: any, ref) => {
    const clases = useEstlosItem();
    const { manejarToggle, checkboxMarcadosArr, item, ...others } = props;
    return (
      <div {...others} ref={ref}

      >
        <div style={{cursor: listaDerechaCheckeados.length == 0 ? "move" : "pointer", display: 'flex', justifyContent: 'flex-start', alignItems: 'center', userSelect: 'none'}}
          onClick={props.manejarToggle(props.item)}
          {...(props.item.fijo || listaDerechaCheckeados.length > 0 ? { onPointerDown: (event) => event.stopPropagation() } : {})}
          className={clases.encima}
        >
          <ListItemIcon>
            <Checkbox
              style={{ padding: 0 }}
              checked={props.checkboxMarcadosArr.indexOf(props.item) !== -1}
              tabIndex={-1}
              disableRipple
              disabled={props.item.fijo ? true : false}
              inputProps={{ 'aria-labelledby': props.item.indice }}
            />
          </ListItemIcon>
          <ListItemText id={props.item.indice} style={{ cursor: listaDerechaCheckeados.length == 0 ? "move" : "pointer" ,alignSelf: 'center', color: props.item.fijo ? '#d6d8d8' : '#606060' }} primary={props.item.titulo} />
          <div style={{ flex: '1 1 0' }}></div>
          {
            !props.item.fijo &&
            <IconMenu fontSize="small" style={{ width: '16px', height: '16px', color: listaDerechaCheckeados.length == 0 ? '#606060' : '#d6d8d8' }} />
          }
        </div>
      </div>)
  })

  // sorteable list - Mi espacio
  const SortableItem = (props: any) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
    } = useSortable({ id: props.id });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
    };
    return (
      <Item ref={setNodeRef} item={props.item} style={style} {...attributes} {...listeners} manejarToggle={props.manejarToggle} checkboxMarcadosArr={props.checkboxMarcadosArr} />
    );
  }

  // lista Mi espacio
  const listaMiEspacio = (items: IListItem[]) => {
    return (<DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragStart={manjearDragComienzo}
      onDragEnd={manejarDragFinal}
      modifiers={[restrictToVerticalAxis, restrictToWindowEdges]}
    >
      <SortableContext items={items} strategy={verticalListSortingStrategy} >
        {<List className={clases.list +" "+ clases.listSeleccionados} dense component="div" role="list" style={{ touchAction: 'none' }}>
          {items.map((item: IListItem) => (
            <ListItem key={item.id} role="listitem" button onClick={manejarToggle(item)} disabled={item.fijo ? true : false}>
            < SortableItem key={item.id} id={item.id} item={item} manejarToggle={manejarToggle} checkboxMarcadosArr={checkboxMarcadosArr} />
            </ListItem>
          ))}
        </List>
        }
      </SortableContext>
    </DndContext>
    );

  }

  const listaCustomizada = (title: string, items: IListItem[], acciones?: any, showitems?: boolean) => (
    <React.Fragment>
      <div className={clases.titulo}>{title} {showitems ? `(${items.length})` : ""} {acciones}</div>
      <Card elevation={2} square>
        {
          title === nombreLista.Disponibles ? (listaDisponibles(items)) : (listaMiEspacio(items))
        }
      </Card>
    </React.Fragment>
  );

  const manejarCambioTab = (index: number) => {
    setearListaSeleccionada(index);
    setearCheckboxMarcadosArr([]);
  }

  const printarCabeceraListas = (listas: IListas[]) => (
    <Tabs
      value={listaSeleccionada}
      //onChange={handleChange}
      variant="scrollable"
      scrollButtons="on"
      //allowScrollButtonsMobile
      aria-label="scrollable force tabs example"
    >
      {
        listas.map( (lista, index) => {
          return <Tab key={`tab-${index}`} className={clases.titulo} label={lista.displayName} onClick={ () => manejarCambioTab(index) } />
        })
      }
    </Tabs>
  );

  const listasCustomizadas = (listas: IListas[]) => (
    <React.Fragment>
      {printarCabeceraListas(listas)}
      <Card elevation={2} square>
        {listaDisponibles(listas[listaSeleccionada].items)}
      </Card>
    </React.Fragment>
  );

  const manjearDragComienzo = (event: any) => {
    const { active } = event;
    setActiveId(active.id);
  }

  const manejarDragFinal = (event: any) => {
    const { active, over } = event;
    const idsseleccionadosFijos = listaDerecha.filter(element => element.fijo).map(elemento => (elemento.id));
    if (active.id !== over.id && !(idsseleccionadosFijos.includes(over.id.toString())) && !idsseleccionadosFijos.includes(active.id.toString())) {
      setearListaDerecha((items) => {
        // TODO investigate type of event and type of id
        const oldIndex = items.findIndex((item: IListItem) => item.id == active.id)
        const newIndex = items.findIndex((item: IListItem) => item.id == over.id)
        const temp = arrayMove(items, oldIndex, newIndex);
        return temp
      });
    }
    setActiveId(null);
  }

  const manejarSubirElementos = () => {
    var lista = listaDerechaCheckeadosNoFijos.sort((item1, item2) => listaDerecha.indexOf(item1) - listaDerecha.indexOf(item2));

    lista.forEach((active: IListItem) => {
      setearListaDerecha((items) => {
        // TODO investigate type of event and type of id
        const oldIndex = items.findIndex((item: IListItem) => item.id == active.id)
        const newIndex = oldIndex - 1;
        const temp = arrayMove(items, oldIndex, newIndex);
        return temp
      });
    })
  }

  const manejarBajarElementos = () => {
    var lista = listaDerechaCheckeadosNoFijos.sort((item1, item2) => listaDerecha.indexOf(item2) - listaDerecha.indexOf(item1));

    lista.forEach((active: IListItem) => {
      setearListaDerecha((items) => {
        // TODO investigate type of event and type of id
        const oldIndex = items.findIndex((item: IListItem) => item.id == active.id)
        const newIndex = oldIndex + 1;
        const temp = arrayMove(items, oldIndex, newIndex);
        return temp
      });
    })
  }

  const minIndex = (lista: IListItem[], seleccion: IListItem[]) => {
    var index = lista.length;
    seleccion.forEach((item) => {
      var current = lista.indexOf(item);
      if (current < index) index = current;
    })

    return index;
  }


  const maxIndex = (lista: IListItem[], seleccion: IListItem[]) => {
    var index = 0;
    seleccion.forEach((item) => {
      var current = lista.indexOf(item);
      if (current > index) index = current;
    })

    return index;
  }


  return (
    <Grid
      container
      spacing={4}
      justify="center"
      alignItems="center"
      style={{ width: '100%' }}
      className={clases.root}
    >
      <Grid item className={clases.zonaDisponibles}>{listasCustomizadas(listas)}</Grid>
      <Grid item className={clases.zonaAccionesCentro}>
        <Grid container direction="column" alignItems="center">
          <IconButton
            className={clases.button}
            onClick={manejarPonerMarcadosALaDerecha}
            disabled={ (listaIzquierdaCheckeados.length === 0) || listaIzquierdaCheckeados.length + listaDerecha.length > (props.maxSeleccionados ?? Infinity)}
            aria-label="move selected right"
          >
            <IconDerecha style={{ width: '18px', height: '18px' }}></IconDerecha>
          </IconButton>
          <IconButton
            className={clases.button}
            onClick={manejarPonerMarcadosALaIzquierda}
            disabled={listaDerechaCheckeadosNoFijos.length == 0}
            aria-label="move selected left"
          >
            <IconIzquierda style={{ width: '18px', height: '18px' }}></IconIzquierda>
          </IconButton>
        </Grid>
      </Grid>
      <Grid item className={clases.zonaSeleccionados}>{listaCustomizada(nombreLista.Seleccionados, listaDerecha, <span style={{ float: "right", marginTop: "-5px" }}><IconButton
        size="small"
        className={clases.button}
        onClick={manejarSubirElementos}
        disabled={listaDerechaCheckeadosNoFijos.length == 0 || minIndex(listaDerecha, listaDerechaCheckeadosNoFijos) == 0 || listaDerecha[minIndex(listaDerecha, listaDerechaCheckeadosNoFijos) -1]?.fijo}
        aria-label="move selected left"
      >
        <IconArriba style={{ width: '16px', height: '16px' }}></IconArriba>
      </IconButton><IconButton
        size="small"
        className={clases.button}
        onClick={manejarBajarElementos}
        disabled={listaDerechaCheckeadosNoFijos.length == 0 || maxIndex(listaDerecha, listaDerechaCheckeadosNoFijos) == listaDerecha.length - 1 || listaDerecha[maxIndex(listaDerecha, listaDerechaCheckeadosNoFijos) +1].fijo}
        aria-label="move selected left"
        style={{ marginLeft: "3px" }}
      >
          <IconAbajo style={{ width: '16px', height: '16px' }}></IconAbajo>
        </IconButton></span>, true)}</Grid>
    </Grid>
  );
})

export default GestionMultiplesListas;